module.exports = __webpack_public_path__ + "b96d0ac5232ce27e0a7b59a28dcbeda3.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/medium/public/games/sm_image_3.png
// module id = 502
// module chunks = 0